"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Recipients/CampaignCsvSteps.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _broadcastGate = require('shared/services/broadcastGate');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _format = require('web/screens/Broadcast/format');

var _Form = require('web/components/Form');
var _helpers = require('../helpers');
var _pending = require('./pending');
var _download = require('./download');
var _CsvReview = require('./CsvReview'); var _CsvReview2 = _interopRequireDefault(_CsvReview);

var _GateBlock = require('./GateBlock'); var _GateBlock2 = _interopRequireDefault(_GateBlock);
var _gateRefusal = require('./gateRefusal');












const fileOf = (file) => ({
  id: _pending.pendingId.call(void 0, 'file'),
  fileName: file.fileName,
  fileSize: file.fileSize,
  fileKey: file.fileKey,
  columns: file.columns,
  mapping: file.mapping,
  excludedRows: [],
  skipMissingFor: [],
})

/* Rev 31 v2 · 4b: Add from CSV's review step and the Add. The file's rows
 * before the Add (remove one; rows aren't edited here since Rev 34 S1), which
 * adds them to the campaign (Rev 31: Add saves immediately; P2': in the
 * background, so the dialog closes as soon as the server takes it). While
 * the Add is being sent the dialog can't be closed or changed (review
 * R800-54), and a refusal keeps it open with the reason (review R800-59). */
const CampaignCsvSteps = ({
  file, isActive, stepLabel, onBack, setBusy, campaign, onAdd, onSetDefault,
}) => {
  const [error, setError] = _react.useState(null)
  // The rows under review. The dialog gives these steps a new key for each
  // mapped file, so they start from that file.
  const [pending, setPending] = _react.useState(() => ({ files: [fileOf(file)], rows: [] }))
  const [view, setView] = _react.useState('all')
  const [offset, setOffset] = _react.useState.call(void 0, 0)
  const [isAdding, setIsAdding] = _react.useState.call(void 0, false)
  // Set at once, so a second press before the re-render adds nothing (R800-52).
  const addingRef = _react.useRef.call(void 0, false)
  const shownError = isActive ? error : null

  const { loaded, isCurrent: isReviewCurrent, error: reviewError } = _CsvReview.useReview.call(void 0, 
    campaign, isActive ? pending : null, view, offset,
  )
  if (!isActive) return null

  const totals = _optionalChain([loaded, 'optionalAccess', _ => _.preview, 'access', _2 => _2.Totals])
  const gateBlock = _optionalChain([loaded, 'optionalAccess', _3 => _3.preview, 'access', _4 => _4.GateBlocksCommit]) && !loaded.preview.Gate.Ready
    ? loaded.preview.Gate
    : null
  const adding = _nullishCoalesce(_optionalChain([totals, 'optionalAccess', _5 => _5.NewRecipients]), () => ( 0))
  // Rev 32 V5: people already in the campaign whose values the file changes.
  const already = _nullishCoalesce(_optionalChain([totals, 'optionalAccess', _6 => _6.AlreadyInCampaign]), () => ( 0))
  const updating = _nullishCoalesce(_optionalChain([totals, 'optionalAccess', _7 => _7.UpdatedRecipients]), () => ( 0))
  const addLabel = adding && updating ? `Add ${_format.formatCount.call(void 0, adding)} · update ${_format.formatCount.call(void 0, updating)}`
    : updating ? `Update ${_format.pluralize.call(void 0, updating, 'recipient', 'recipients')}`
      : `Add ${_format.pluralize.call(void 0, adding, 'recipient', 'recipients')}`

  const onAddClick = () => {
    if (addingRef.current) return
    addingRef.current = true
    setIsAdding(true)
    setBusy(true)
    setError(null)
    onAdd(pending, adding || updating)
      .catch((e) => {
        const gate = _broadcastGate.campaignGateFromError.call(void 0, e)
        setError(gate ? _gateRefusal.gateRefusalText.call(void 0, gate) : _helpers.errorText.call(void 0, e, "Couldn't add the recipients"))
      })
      .finally(() => {
        addingRef.current = false
        setIsAdding(false)
        setBusy(false)
      })
  }
  const onDownloadErrors = () => {
    const pendingFile = pending.files[0]
    if (!pendingFile) return
    _actions2.default.downloadRecipientErrors({ CampaignKey: campaign.CampaignKey, FileKey: pendingFile.fileKey, Mapping: pendingFile.mapping })
      .then(({ FileName, Csv }) => _download.downloadText.call(void 0, FileName || `${pendingFile.fileName.replace(/\.csv$/i, '')}-errors.csv`, Csv, 'text/csv'))
      .catch((e) => setError(_helpers.errorText.call(void 0, e, "Couldn't download the rows")))
  }
  const onSkipMissing = (variable) => setPending(p => _pending.updateFile.call(void 0, p, _nullishCoalesce(_optionalChain([p, 'access', _8 => _8.files, 'access', _9 => _9[0], 'optionalAccess', _10 => _10.id]), () => ( '')), f => f.skipMissingFor.includes(variable)
    ? f
    : { ...f, skipMissingFor: [...f.skipMissingFor, variable] }))

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('p', { className: "broadcast-csv-review--step", __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}},  stepLabel(2, 'Review rows') )
      , _react2.default.createElement(_CsvReview2.default, {
        fileName: _nullishCoalesce(_optionalChain([pending, 'access', _11 => _11.files, 'access', _12 => _12[0], 'optionalAccess', _13 => _13.fileName]), () => ( '')),
        pending: pending,
        onChange: update => {
          setError(null)
          setPending(update)
        },
        view: view,
        onView: v => {
          setView(v)
          setOffset(0)
        },
        offset: offset,
        onOffset: setOffset,
        loaded: loaded,
        isCurrent: isReviewCurrent,
        isAdding: isAdding,
        onDownloadErrors: onDownloadErrors, __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}
      )
      ,  gateBlock && (
        _react2.default.createElement(_GateBlock2.default, { gate: gateBlock, onSkip: onSkipMissing, onSetDefault: onSetDefault, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}} )
      )
      ,  (shownError || reviewError) && _react2.default.createElement('p', { role: "alert", className: "broadcast-wizard--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}},  shownError || reviewError ) 
      , _react2.default.createElement('div', { className: "broadcast-upload-dialog--foot broadcast-upload-dialog--foot--sticky" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}
        ,  totals && (
          _react2.default.createElement('div', {
            'aria-label': "What the file adds"   ,
            'aria-busy': !isReviewCurrent,
            className: _classBuilder2.default.call(void 0, 'broadcast-upload-dialog--sum', !isReviewCurrent && 'broadcast-upload-dialog--sum--stale'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}}

            ,  already > 0
              ? (
                  _react2.default.createElement(_react2.default.Fragment, null
                    , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 142}},  _format.formatCount.call(void 0, adding) ), " new · "   , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 142}},  _format.formatCount.call(void 0, already) ), " already in the campaign"
                    , ' ', "(", _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 143}},  _format.formatCount.call(void 0, updating) ), " with updated values)"
                  )
                )
              : _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 146}},  _format.formatCount.call(void 0, adding) ), " will be added"   )
            
            ,  totals.FailedRowCount > 0 && (
              _react2.default.createElement(_react2.default.Fragment, null
                , ' · '
                , _react2.default.createElement('span', { className: "broadcast-upload-dialog--sum-skipped", __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}}
                  ,  _format.formatCount.call(void 0, totals.FailedRowCount) , " can't be added"
                )
                , ' ', "(no valid phone or email)"
              )
            )
          )
        )
        , _react2.default.createElement('span', { className: "broadcast-upload-dialog--grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}} )
        , _react2.default.createElement(_Form.Button, { isSecondary: true, isDisabled: isAdding, onClick: () => { setError(null); onBack() }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}}, "Back")
        , _react2.default.createElement(_Form.Button, {
          isDisabled: !isReviewCurrent || (adding === 0 && updating === 0) || !!gateBlock,
          isLoading: isAdding,
          onClick: onAddClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}

          ,  addLabel 
        )
      )
    )
  )
}

exports. default = CampaignCsvSteps
